import React from 'react';
import {Box, CssBaseline} from "@mui/material";
import {Navigate, Route, Routes} from 'react-router-dom';
import Calendar from "../views/Calendar";
import Header from "../components/main/header/Header";
import NavigationBar from "../components/main/navigation/NavigationBar";
import Appointment from "../views/Appointment";
import DailyReconciliation from "../views/DailyReconciliation";
import Reconciliation from "../views/Reconciliation";
import Review from "../views/Review";
import Doctor from "../views/Doctor";
import ReplyPage from "../components/review/ReplyPage";
import DoctorEdit from "../components/doctor/DoctorEdit";
import SpecialitiesManage from "../components/doctor/SpecialitiesManage";
import ProceduresManage from "../components/doctor/ProceduresManage";
import MonthDataPage from "../components/reconcelation/MonthDataPage";

const AdminPage = () => {
    return (
        <Box>
            <Header/>
            <CssBaseline/>
            <NavigationBar/>

            <Box sx={{maxWidth: "100%"}}>
                <Routes>
                    <Route path={"calendar"} element={<Calendar/>}/>
                    <Route path={"appointment"} element={<Appointment/>}/>
                    {/*<Route path={"appointment/status-change"} element={<StatusChangePage/>}/>*/}
                    <Route path={"daily-reconciliation"} element={<DailyReconciliation/>}/>
                    <Route path={"reconciliation"} element={<Reconciliation/>}/>
                    <Route path={"reconciliation/month-data"} element={<MonthDataPage/>}/>
                    <Route path={"reviews"} element={<Review/>}/>
                    <Route path={"reviews/reply"} element={<ReplyPage/>}/>
                    <Route path={"doctors/one"} element={<DoctorEdit/>}/>
                    <Route path={"doctors/one/speciality"} element={<SpecialitiesManage/>}/>
                    <Route path={"doctors/one/procedure"} element={<ProceduresManage/>}/>
                    <Route path={"doctors"} element={<Doctor/>}/>
                    <Route path="/" element={<Calendar/>}/>
                    <Route
                        path="//*"
                        element={<Navigate to="/app/calendar"/>}
                    />
                </Routes>
            </Box>

        </Box>
    );
};

export default AdminPage;